// 사업영역 사이드바/드롭다운 공용 메뉴 (모든 사업영역 페이지에서 공유)
export const businessMenus = [
  { label: '실내건축', path: '/business/interior' },
  { label: '조경식재', path: '/business/landscape' },
  { label: '금속구조물·지붕', path: '/business/metal' },
  { label: '도장·방수·석공사', path: '/business/finishing' },
  { label: '지반조성·포장', path: '/business/pavement' },
  { label: '건물종합관리', path: '/business/management' },
  { label: '물탱크청소', path: '/business/tank' },
  { label: '소독업', path: '/business/disinfection' },
];
